<template>
  <el-autocomplete
    v-model="tempValue"
    @select="selectSchool"
    :fetch-suggestions="querySearchAsync"
    placeholder="请输研究科"
    :icon="icon"
    :on-icon-click="clearInput"
    :blur="clearInput"
  />
</template>

<script>
export default {
  name: 'JmSchoolSearch',
  props: {
    schoolId: {
      type: [Number],
    },
    value: [Object],
    clearable: {
      type: Boolean,
      default: false,
    }
  },
  model: {
    event: 'change',
  },
  data() {
    return {
      tempValue: null,
    };
  },
  computed: {
    icon() {
      return this.tempValue && this.clearable ? 'circle-close' : '';
    }
  },
  methods: {
    querySearchAsync(name, cb) {
      if (!name || !this.schoolId) {
        cb([]);
        this.selectSchool(null);
        return false;
      }
      this.$http._get({
        url: '/index/api_base/searchSchoolOrg',
        data: {
          sh_id: this.schoolId,
          name,
        }
      }).then(({ data }) => {
        const schoolData = Array.isArray(data) ? data : Object.values(data);
        let schools = [];
        schoolData.forEach((item) => {
          item.value = item.o_name_ww;
          schools.push(item);
        });
        if (schools.length === 0) {
          this.$emit(
            'change',
            {
              o_name_ww: name,
              oid: null,
              value: name,
            }
          );
        }
        cb(schools);
      });
    },
    selectSchool(val) {
      this.$emit('change', val);
    },
    clearInput() {
      this.tempValue = '';
      this.selectSchool(null);
    }
  },
  watch: {
    value(v) {
      if (!v) {
        this.clearInput();
      }
    },
    schoolId() {
      this.clearInput();
    }
  }
};
</script>
